/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import "./style.less";

class PipelineImgs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  handleItemClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    if (!item.link) {
      // 空白不跳转
      return;
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      link: item.link,
      type: baseConfig.sortType,
      sort: index,
    };

    const convertUrl = utils.convertHref(item.link);
    utils.jumpToUrl(this.props.routeParams,convertUrl,item.link, options, -1,this.props,false);
  };

  render() {
    const { baseConfig, imgsList } = this.props.config;

    // 判断不同布局方式下的间距取值
    if (baseConfig.sortType === "一行一图") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.sortType === "一行二图") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.sortType === "一行三图") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.sortType === "banner") {
      Object.assign(baseConfig, baseConfig.layout_banner);
    }

    // 转为数字处理，后续参与计算
    baseConfig.imgMarginHorizon = isNaN(Number(baseConfig.imgMarginHorizon))
      ? 0
      : Number(baseConfig.imgMarginHorizon);
    baseConfig.imgMarginVertical = isNaN(Number(baseConfig.imgMarginVertical))
      ? 0
      : Number(baseConfig.imgMarginVertical);
    return (
      <div
        id={baseConfig.moduleId}
        className="pipeline-imgs"
        {...this.props['customAttributes']}
        style={{
          paddingTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        <div className="img-list">
          {imgsList.map((item, index) => {
            let rowItemNumber = 3; // 每行排列数量
            if (
              baseConfig.sortType === "一行一图" ||
              baseConfig.sortType === "banner"
            ) {
              rowItemNumber = 1;
            } else if (baseConfig.sortType === "一行二图") {
              rowItemNumber = 2;
            } else if (baseConfig.sortType === "一行三图") {
              rowItemNumber = 3;
            }

            const isFirstRow = Boolean(index < rowItemNumber); // 该项是否在首行
            const isLasthRow = Boolean(imgsList.length - index < rowItemNumber); // 该项是否在未行
            const isFirstColumn = Boolean(index % rowItemNumber === 0);
            const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

            // 计算每个项的宽度
            const totalMargin =
              (rowItemNumber - 1) * baseConfig.imgMarginHorizon;
            const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
            const itemStyle = {
              width: itemWidth,
              marginTop: isFirstRow
                ? "0"
                : `${baseConfig.imgMarginVertical / 2}px`,
              marginBottom: isLasthRow
                ? "0"
                : `${baseConfig.imgMarginVertical / 2}px`,
              marginLeft: isFirstColumn
                ? "0"
                : `${baseConfig.imgMarginHorizon / 2}px`,
              marginRight: isLastColumn
                ? "0"
                : `${baseConfig.imgMarginHorizon / 2}px`,
            };

            // 判断图片圆角值
            let imgBorderRadius = "6px";
            if (baseConfig.sortType === "banner" || baseConfig.noImgRadius) {
              // banner图片或者选择不添加圆角情况，值为0
              imgBorderRadius = "0";
            }
            return (
              <div
                className="img-item"
                key={index}
                style={itemStyle}
                onClick={this.handleItemClick.bind(this, item, index)}
              >
                <img
                  className="img"
                  style={{ borderRadius: imgBorderRadius }}
                  src={utils.formatImgUrl(item.src, this.props.webpSupport)}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

PipelineImgs.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImgs };
export default PipelineImgs;



// WEBPACK FOOTER //
// ./components/pipeline-imgs/index.js